module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/steps/event-areas/assets/sessions-3a968e3bc627ec6c1f5f337388187166.png";